module.exports = __webpack_public_path__ + "img/fr.d33b224d.png";